import axios from 'axios';
import { message } from 'antd';

const post = async (url, data) => {
    const result = await axios.post(url, data);
    if (result.status == 200) {
        message.success("İşlem başarılı.")
    }
    return result?.data;
};

export default post;